__turbopack_context__.v({
  "bagEmpty": "empty-module-scss-module__ZjLeHG__bagEmpty",
  "bagEmptyBlock": "empty-module-scss-module__ZjLeHG__bagEmptyBlock",
  "black-bt": "empty-module-scss-module__ZjLeHG__black-bt",
  "btnCustom": "empty-module-scss-module__ZjLeHG__btnCustom",
  "checkoutLogged": "empty-module-scss-module__ZjLeHG__checkoutLogged",
});
